// extracted by mini-css-extract-plugin
module.exports = {"user":"Styles_user__23yDq"};